import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/ManagePackage/tab/Excludes/Views/excludes.html';
import GeneralModule from '@/Pages/Admin/Modules/ManagePackage/Store/General';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import ValidationError from '@/Pages/Admin/Modules/Common/Controllers/ValidationError';
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';
import {TrekExcludeModel} from '@/Pages/Admin/Modules/Models/ManagePackage/Tab/Excludes/TrekExcludeModel';


@WithRender
@Component({
    components: {
        'validation-error': ValidationError
    }
})
export default class Excludes extends Vue {
    protected ui: any = {};
    protected item: any = {};

    constructor() {
        super();

        this.ui = {
            index: {
                edit: -1,
                delete: -1,
                up: 0,
                down: 0,
            },
            status: {
                isLoading: {
                    getExcludesList: false,
                },
                postLoading: {
                    create: false,
                    update: false,
                    delete: false,
                },
                canAdd: false,
                canEdit: false,
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
                modal: {
                    delete: {},
                },
            },
        };

        this.item = {
            excludesList: new TrekExcludeModel({}),
            addExclude: new TrekExcludeModel({}),
            editExclude: new TrekExcludeModel({}),
            deleteExclude: new TrekExcludeModel({}),
            tempExclude: new TrekExcludeModel({}),
            upExclude: new TrekExcludeModel({}),
            downExclude: new TrekExcludeModel({}),
        };
    }

    public mounted() {
        this.getExcludesList();
    }

    get permission() {
        return common.permissionCheck;
      }

    get getAllIconsList() {
        return GeneralModule.Icons;
    }

    public getExcludesList() {
        let data = {
            trek_id: this.$route.query.id
        };
        this.ui.status.isLoading.getExcludesList = true;
        trekService
            .getExcludesList(data)
            .then((res: any) => {
                res.data.data.filter((list: any) => {
                    list.IsActive = false;
                });
                this.item.excludesList = res.data.data;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
                    this.ui.error.errors = res;
                    this.ui.error.has_error = true;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.getExcludesList = false;
            });
    }

    protected addExcludes() {
        this.resetError();

        if (!this.validateAddExcludeAction()) {
            return;
        }
        let data = {
            trek_id: this.$route.query.id,
            icon_id: this.item.addExclude.icon.id,
            title: this.item.addExclude.title
        };
        this.ui.status.postLoading.create = true;
        trekService
            .addExcludes(data)
            .then((res: any) => {
                this.ui.status.canAdd = false;
                this.item.excludesList.unshift(res.data.data);
                this.item.addExclude = new TrekExcludeModel({});
                flashService.Success('Exclude Added', res.data.message);
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.create = false;
            });
    }

    protected validateAddExcludeAction() {
        let list = this.item.addExclude;
        if (!list.title) {
            Object.assign(this.ui.error.errors, {
                title: ['The title field is required.']
            });
        }
        if (list.icon === null || list.icon.id === 0) {
            Object.assign(this.ui.error.errors, {
                icon_id: ['The icon field is required.']
            });
        }
        if (common.notEmpty(this.ui.error.errors)) {
            this.ui.error.has_error = true;
            return false;
        } else {
            return true;
        }
    }

    protected onEditExcludesClick(index: any, list: any) {
        this.resetError();
        this.ui.status.canEdit = true;
        this.item.tempExclude = Object.assign({}, list);
        this.ui.index.edit = index;
        list.IsActive = true;
        this.item.editExclude = list;
    }

    protected editExcludes() {
        this.resetError();
        if (!this.validateEditExcludeAction()) {
            return;
        }
        let data = {
            trek_id: this.$route.query.id,
            id: this.item.editExclude.id,
            icon_id: this.item.editExclude.icon.id,
            title: this.item.editExclude.title,
        };
        this.ui.status.postLoading.update = true;
        trekService
            .editExclude(data)
            .then((res: any) => {
                this.ui.status.canEdit = false;
                this.$set(this.item.excludesList, this.ui.index.edit, res.data.data);
                flashService.Success('Exclude Saved', res.data.message);
                this.resetError();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.canEdit = false;
                this.ui.status.postLoading.update = false;
            });
    }

    protected validateEditExcludeAction() {
        let list = this.item.editExclude;
        if (!list.title) {
            Object.assign(this.ui.error.errors, {
                edit_title: ['The title field is required.'],
            });
        }
        if (list.icon === null || list.icon.id === 0) {
            Object.assign(this.ui.error.errors, {
                edit_icon_id: ['The icon field is required.'],
            });
        }
        if (common.notEmpty(this.ui.error.errors)) {
            this.ui.error.has_error = true;
            return false;
        } else {
            return true;
        }
    }

    protected cancelExcludes(index: any, list: any) {
        this.resetError();
        this.ui.status.canEdit = false;
        list.IsActive = false;
        this.ui.index.edit = index;
        this.item.excludesList[index] = this.item.tempExclude;
    }

    protected onDeleteExcludesClick(index: any, list: any) {
        this.resetError();
        this.ui.status.canEdit = false;
        $('#deleteSelectedExcludes').modal('show');
        this.ui.index.delete = index;
        this.item.deleteExclude = list;
    }


    protected deleteExcludes() {
        this.resetError();
        let data = {
            trek_id: this.$route.query.id,
            id: this.item.deleteExclude.id
        };
        this.ui.status.postLoading.delete = true;
        trekService
            .deleteSelectedExcludes(data)
            .then((res: any) => {
                this.$delete(this.item.excludesList, this.ui.index.delete);
                flashService.Success('Exclude Deleted', res.data.message);
                this.hideDeleteModal();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.modal.delete).then(res => {
                    this.ui.error.modal.delete = res;
                });
                flashService.Error('Error', 'Error while deleting Exclude.');
            })
            .finally(() => {
                this.ui.status.postLoading.delete = false;
            });
    }


    protected hideDeleteModal() {
        $('#deleteSelectedExcludes').modal('hide');
        $('.modal-backdrop').remove();
        this.ui.error.modal.delete = {};
        this.resetError();
    }

    public resetError() {
        this.ui.error.errors = {};
        this.ui.error.has_error = false;
        this.ui.error.error_message = {};
    }


    public customLabel(name: any) {
        return name;
    }

    public get buttonTextAddExclude() {
        if (this.ui.status.postLoading.create) {
            return 'Processing...';
        }
        return 'Save Excludes';
    }


    protected showAddExcludeButton() {
        this.ui.status.canAdd = true;
    }

    protected moveExcludeUp(index: any, destination: any) {
        this.item.upExclude = this.item.excludesList[index - 1];
        this.ui.index.up = index - 1;
        this.resetError();
        this.$set(this.item.excludesList, this.ui.index.up, destination);
        this.$set(this.item.excludesList, index, this.item.upExclude);
    }

    protected moveExcludeDown(index: any, destination: any) {
        this.item.downExclude = this.item.excludesList[index + 1];
        this.ui.index.down = index + 1;
        this.resetError();
        this.$set(this.item.excludesList, this.ui.index.down, destination);
        this.$set(this.item.excludesList, index, this.item.downExclude);
    }
}
